import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';
import { MSS_FORMLY_IMPORTS } from '@shared/components/formly/formly-standalone-imports';

@Component({
  templateUrl: 'postcode-input.component.html',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ...MSS_FORMLY_IMPORTS,
  ],
})
export class PostcodeInputComponent extends FieldType {
}
